import { render, staticRenderFns } from "./NoticeMgmtView.vue?vue&type=template&id=36c423c2&"
import script from "./NoticeMgmtView.vue?vue&type=script&lang=js&"
export * from "./NoticeMgmtView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports